import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Brand from 'models/brand';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  app: PropTypes.string.isRequired,
};

const defaultProps = {

};

const AccountHeader = ({
  app,
  brand,
}) => {
  const headerClasses = cx({
    'slim-header': true,
    'primary-gradient-background': !brand.isBestParking,
    'background-color-bp-dark-blue': brand.isBestParking,
  });

  let headerTitle;
  switch (app) {
    case 'Bookings':
      headerTitle = 'My Parking';
      break;
    case 'PaymentMethods':
      headerTitle = 'Payment Methods';
      break;
    case 'AccountSettings':
      headerTitle = 'Account Settings';
      break;
    case 'Vehicles':
      headerTitle = 'Saved Vehicles';
      break;
    case 'Transfer':
      headerTitle = 'Transfer a Pass';
      break;
    default:
      headerTitle = '';
  }

  return (
    <div className={headerClasses}>
      <div className="container">
        <div className="row">
          <div className="col-xs-12 text-size-xs-24 text-size-md-30 text-align-xs-center text-align-md-left" >
            { headerTitle }
          </div>
        </div>
      </div>
    </div>
  );
};

AccountHeader.propTypes = propTypes;
AccountHeader.defaultProps = defaultProps;

export default AccountHeader;
